import store from "../../index.js";
import api from "../../../utils/api";
const publicHost = "https://naezipscan.kredatalab.com";

export const modules = {
  store,
};

export const state = {
  _error: {
    code: null,
    message: null,
  },
};

export const mutations = {
  setError(state, error) {
    state._error = error;
  },
  setClearError(state) {
    state._error = {
      code: null,
      message: null,
    };
  },
};

export const actions = {
  async acOwnerPropertySave({ commit }, payload) {
    try {
      const url = `/api/v1/report/owner-house-property`;
      const res = await api.post(url, {
        properties: payload,
      });
      return res.data?.code === 0 ? true : false;
    } catch (error) {
      return false;
    }
  },
  async acOwnerPropertyConfirm({ commit }, payload) {
    try {
      const url = `/api/v1/report/owner-house-property/${payload.id}/status`;
      const res = await api.patch(url, { status: payload.status, send_yn: payload.send_yn });
      return res.data?.code === 0 ? true : false;
    } catch (error) {
      return false;
    }
  },
  async acOwnerHousePropertySearch({ commit }, payload) {
    try {
      const url = `/api/v1/report/owner-house-property/owner-collection`;
      const res = await api.post(url, payload);
      commit("setError", res.data);
      return res.data?.code === 0 ? true : false;
    } catch (error) {
      commit("setError", error.data);
      return false;
    }
  },
  // NZSC-3034 — 집주인 다른 부동산 재처리 (틸코 API 재호출, 포인트 차감 발생)
  // BE 응답 스펙:
  //   성공 { code:0, message:'success', data:{count, items} }
  //   실패 { code: number, message: string }
  async acOwnerHousePropertyReprocess({ commit }, payload) {
    try {
      const url = `/api/v1/report/owner-house-property/${payload.reportSeq}/reprocess`;
      const res = await api.post(url);
      return res.data;
    } catch (error) {
      return error?.response?.data || { code: -1, message: "서버 오류" };
    }
  },
  async acOwnerHousePropertyReanalyze({ commit }, payload) {
    try {
      const url = `/api/v1/report/owner-house-property/analyze`;
      const res = await api.post(url, payload);
      return res.data?.code === 0;
    } catch (error) {
      return false;
    }
  },
  // NZSC-3879 — 재가동(전체). 성공/실패만이 아니라 처리 요약을 그대로 돌려준다.
  //   성공 { code:0, data:{ targeted, succeeded, skipped, inspection } }
  //   실패 { code:1, message }
  // 이전에는 boolean 만 반환해 화면이 "몇 건 돌았는지"를 알 수 없었다.
  async acOwnerHousePropertyReanalyzeAll({ commit }, payload) {
    try {
      const url = `/api/v1/report/owner-house-property/analyze-all`;
      const res = await api.post(url, payload);
      return res.data;
    } catch (error) {
      return error?.response?.data || { code: -1, message: "서버 오류" };
    }
  },
  async acOwnerHousePropertyAnalyzeDirectInput({ commit }, payload) {
    try {
      const url = `/api/v1/report/owner-house-property/analyze-direct-input`;
      const res = await api.post(url, payload);
      return res.data?.code === 0;
    } catch (error) {
      return false;
    }
  },
};

export const getters = {
  geCodeFail: state => {
    switch (state._error.code) {
      case 0:
        return "조회신청완료";
      case 7509:
        return "신청정보가 없습니다.";
      case 7501:
        return "리포트가 존재하지 않습니다.";
      case 7508:
        return "집주인정보가 올바르지 않습니다.";
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
